(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nt-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nt-newsletter-signup')) {
  customElements.define('nt-newsletter-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const button = form.querySelector('button[type="submit"]');
      const fields = form.querySelector('fieldset');
      const status = this.querySelector('[role="status"]');
      const buttonLabel = button.textContent;
      button.disabled = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        if (form.elements.website.value) return;
        const email = form.elements.email.value.trim();
        button.disabled = true;
        button.textContent = this.dataset.busy;
        form.setAttribute('aria-busy', 'true');
        status.textContent = '';
        status.removeAttribute('data-error');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UzYQkz', {
            method: 'POST',
            credentials: 'omit',
            headers: {'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15'},
            signal: controller.signal,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'naturtotalshop.com Newsletter – Zypern',
                  profile: {data: {type: 'profile', attributes: {
                    email,
                    subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
                  }}}
                },
                relationships: {list: {data: {type: 'list', id: 'SXGDvh'}}}
              }
            })
          });
          if (response.status !== 202) {
            const error = new Error('Subscription not accepted');
            error.rateLimited = response.status === 429;
            throw error;
          }
          form.reset();
          fields.hidden = true;
          status.textContent = this.dataset.success;
          status.focus();
        } catch (error) {
          status.textContent = error.rateLimited ? this.dataset.rateLimit : this.dataset.error;
          status.setAttribute('data-error', '');
          button.disabled = false;
          status.focus();
        } finally {
          clearTimeout(timeout);
          button.textContent = buttonLabel;
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-premium-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const closeHeaderPanels = (except) => {
    document.querySelectorAll('.nt-header details[open]').forEach((panel) => {
      if (panel !== except) panel.removeAttribute('open');
    });
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.nt-header')) closeHeaderPanels();
    const summary = event.target.closest('.nt-header summary');
    if (summary) closeHeaderPanels(summary.parentElement);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = document.querySelector('.nt-header details[open]');
    if (panel) {
      const summary = panel.querySelector('summary');
      closeHeaderPanels();
      if (summary) summary.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
